import Layout from "@/components/feature/Layout";
import SectionHeading from "@/components/feature/SectionHeading";
import MovieCard from "@/components/feature/MovieCard";
import { useSeo } from "@/hooks/useSeo";
import { Link } from "react-router-dom";
import { heroSlides, newsList } from "@/mocks/news";
import { channels } from "@/mocks/channels";
import { movies } from "@/mocks/movies";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import NewsList from "@/pages/home/components/NewsList";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import ChannelScroll from "@/pages/home/components/ChannelScroll";

const featured = movies.slice().sort((a, b) => b.hot - a.hot).slice(0, 8);

export default function Home() {
  useSeo({
    title: "黑桃视频－最新影视资讯与影视频道推荐",
    description:
      "黑桃视频提供丰富的影视内容资讯，包括最新电影、电视剧及热门影视频道，满足用户多样化观影需求，打造专业影视聚合平台。",
    keywords: "黑桃视频,影视资讯,电影推荐,电视剧更新,影视频道,热门影视,影视内容,观影指南",
  });

  return (
    <Layout>
      <div className="mx-auto w-full max-w-[1440px] px-4 pt-8 md:px-8 md:pt-10">
        <h1 className="sr-only">黑桃视频 - 最新影视资讯与影视频道推荐</h1>

        <div className="flex flex-col gap-8 lg:flex-row">
          <div className="flex min-w-0 flex-1 flex-col gap-8">
            <HeroCarousel slides={heroSlides} />
            <NewsList items={newsList} />
          </div>

          <aside className="flex w-full flex-col gap-8 lg:w-[360px]">
            <CategoryGrid />
            <ChannelScroll items={channels.slice(0, 5)} />
          </aside>
        </div>

        <section className="mt-14" aria-labelledby="featured-movies">
          <SectionHeading
            icon="ri-fire-line"
            title="本周热播精选"
            subtitle="按热度排序的高关注影视作品"
            moreTo="/category"
          />
          <div className="grid grid-cols-2 gap-3.5 sm:grid-cols-3 lg:grid-cols-4">
            {featured.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        </section>
      </div>

      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8">
        <div className="mt-14 flex flex-col gap-6 rounded-xl border border-background-200 bg-background-100 p-6 md:flex-row md:items-center md:justify-between md:p-8">
          <div>
            <h4 className="font-heading text-xl font-600 text-foreground-950">不确定看什么？</h4>
            <p className="mt-2 text-sm text-foreground-600">
              进入影视分类页，按地区、年份与类型快速筛选，或直接在顶部搜索你想找的作品。
            </p>
          </div>
          <div className="flex shrink-0 gap-3">
            <Link
              to="/category"
              className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-500 text-background-50 transition-colors hover:bg-primary-600"
            >
              去分类浏览
            </Link>
            <Link
              to="/channel"
              className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-500 text-foreground-800 transition-colors hover:border-accent-400 hover:text-accent-500"
            >
              看频道推荐
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}